const faqs = [
  {
    question: "Does Alabama have its own regional passport agency?",
    answer: "No — Alabama does not have a regional passport agency. The closest regional agency is the Atlanta Passport Agency in Georgia, approximately 2–3 hours from Birmingham. Using a registered courier like Fast Passport Center is typically faster and more convenient than visiting a regional agency.",
  },
  {
    question: "How fast can I get a passport in Alabama?",
    answer: "With Fast Passport Center's courier service, Alabama travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Alabama?",
    answer: "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility — typically a post office, county clerk, or public library. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which airport should I fly from for international travel from Alabama?",
    answer: "Birmingham-Shuttlesworth (BHM) and Huntsville International (HSV) are Alabama's primary airports. For broader international connections, many Alabama residents drive to Atlanta Hartsfield-Jackson (ATL) approximately 2.5 hours from Birmingham or to Nashville (BNA) for travelers in North Alabama.",
  },
  {
    question: "I am stationed at Redstone Arsenal or Fort Novosel — can I get a military passport?",
    answer: "Military members on official orders can apply for a no-fee passport at their military installation's passport office. For personal travel, service members use the regular civilian passport process. Fast Passport Center's courier service works for both, though military installations have their own procedures for official no-fee passports.",
  },
  {
    question: "Where is the best place to get a passport photo in Alabama?",
    answer: "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations across Alabama offer passport photo services. Most offer walk-in service. Always verify the photo meets State Department requirements (2×2 inches, white background, taken within 6 months) before submitting.",
  },
];

export { faqs };

export default function ALFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Alabama Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Alabama.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}